<template>
  <div>
    <van-field v-model="fieldValue" is-link readonly :placeholder="issue.placeholder" @click="show = true" />
    <van-popup v-model="show" round position="bottom">
      <van-cascader
          v-model="cascaderValue"
          title="请选择所在地区"
          :options="issue.groups"
          @close="show = false"
          @finish="onFinish"
          :field-names="fieldNames"
      />
    </van-popup>
  </div>
</template>

<script>
import { questionType } from 'dygc'

export default {
  name: 'VoteCascadeSearch',
  type: [questionType.LINKAGE],
  props: {
    question: Object,
  },
  computed: {
    issue() {
      return this.question.issue
    }
  },
  data() {
    return {
      fieldValue: '',
      show: false,
      cascaderValue: '',
      options: [],
      fieldNames: {
        text: 'content',
        value: 'id',
        children: 'nextLevelOptions'
      }
    }
  },
  methods: {
    onFinish({ selectedOptions }) {
      this.show = false
      this.fieldValue = selectedOptions.map(option => option.content).join('/')
      this.issue.voteAnswer = selectedOptions.map(i => i.id)
    }
  },
  mounted() {
    if (this.issue.voteAnswer) {
      const list = this.issue.toOneArray()
      const results = []
      list.forEach(item => {
        const lastId = item.id.split('/').pop()
        if (this.issue.voteAnswer.includes(lastId)) {
          results.push(item.text)
        }
      })
      this.fieldValue = results.join(',')
    }
  }
}
</script>

<style scoped>

</style>